import React from "react";
import { TAGS } from "./Tags";

const skills = [
  TAGS.REACT,
  TAGS.JS,
  TAGS.HTML,
  TAGS.CSS,
  TAGS.PYTHON,
  TAGS.DJANGO,
  TAGS.TAILWIND,
  TAGS.BOOTSTRAP,
  TAGS.MUI,
  TAGS.VITE,
];

const Skills = () => {
  return (
    <section id="my-skills" className="mb-10">
      <h2 className="text-2xl font-bold mb-6 text-dark">Habilidades</h2>
      <div className="flex flex-wrap gap-3">
        {skills.map((skill, index) => (
          <div
            key={index}
            className="flex items-center gap-2 px-4 py-2 bg-bg2 border border-dark/10"
          >
            <div className={skill.class.replace("h-6 w-6", "w-5 h-5")}>
              {skill.icon}
            </div>
            <span className="text-sm text-dark">{skill.name}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
